var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvtarManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_2955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99713 14.6603C11.6776 14.6603 14.6613 11.6767 14.6613 7.99616C14.6613 4.31566 11.6776 1.33203 7.99713 1.33203C4.31664 1.33203 1.33301 4.31566 1.33301 7.99616C1.33301 11.6767 4.31664 14.6603 7.99713 14.6603Z",
    stroke: "white",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99728 8.66254C9.10143 8.66254 9.99652 7.76745 9.99652 6.6633C9.99652 5.55915 9.10143 4.66406 7.99728 4.66406C6.89314 4.66406 5.99805 5.55915 5.99805 6.6633C5.99805 7.76745 6.89314 8.66254 7.99728 8.66254Z",
    stroke: "white",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66504 13.7685V12.6609C4.66504 12.3075 4.80546 11.9685 5.05541 11.7185C5.30537 11.4685 5.64438 11.3281 5.99786 11.3281H9.99634C10.3498 11.3281 10.6888 11.4685 10.9388 11.7185C11.1887 11.9685 11.3292 12.3075 11.3292 12.6609V13.7685",
    stroke: "white",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_2955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9939,
    height: 15.9939,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvtarManagement);
export default __webpack_public_path__ + "static/media/avtar_management.c7158842b8c3c9ef4207775b8101b3f3.svg";
export { ForwardRef as ReactComponent };